/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { useLocation, useNavigate } from "react-router-dom";

const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  background: "#2B2B2B",
  border: "1px solid #424242",
  boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.4)",
}));

function RecommendedItemBar() {
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const shouldRenderCategories = location === "/RECOMMENDED_VIEW";
  const onSkipRecommendations = () => {
    navigate(-1);
  };
  return (
    <Stack
      direction='row'
      sx={{
        display: shouldRenderCategories ? "inline" : "none",
        flexDirection: "row",
        flexGrow: 1,
        justifyContent: "center",
        width: "100%",
        marginBottom: 2.5,
      }}
    >
      <Item
        sx={{
          "& button": {
            marginTop: 0,
            marginBottom: 0,
            marginRight: 1,
            marginLeft: 1,
          },
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant='h6' paddingX={2}>
          Recommendations
        </Typography>
        <Button variant='outlined' onClick={onSkipRecommendations}>
          Skip Recommendations
        </Button>
      </Item>
    </Stack>
  );
}

export default RecommendedItemBar;
